<template>
    <v-container fluid class="pt-0">
        <user-stats />
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <h2
                                    >{{
                                        $t(
                                            'dashboardView.listOfYourNotConfirmedVacationsTitle'
                                        )
                                    }}
                                </h2>
                            </v-col>
                        </v-row>
                        <vacation-request-list
                            :vacations="notConfirmedVacations"
                            :visibilityConfig="{
                                search: false,
                                refresh: true,
                                excludeHeaders: [
                                    'user.firstName',
                                    'user.lastName',
                                    'isConfirmed',
                                    'action'
                                ]
                            }"
                            @refresh="onRefreshVacations"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'userDashboard',

    components: {
        VacationRequestList: () => import('@/components/VacationRequestList'),
        UserStats: () => import('@/components/UserStats')
    },

    computed: {
        ...mapGetters({
            notConfirmedVacations: 'vacations/getNotConfirmedVacations'
        })
    },

    async created() {
        await this.fetchNotConfirmedVacations();
    },

    methods: {
        ...mapActions({
            fetchNotConfirmedVacations: 'vacations/fetchNotConfirmed'
        }),

        async onRefreshVacations() {
            await this.fetchNotConfirmedVacations();
        }
    }
};
</script>
